<template>
  <div class="newsInformation">
    <detailsTop :topIndex="topIndex" @bannerIndexClick="bannerIndexClick" />
    <div class="news-content">
      <div class="new-left"></div>
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          @changeTips="changeTips"
          :bannerIndex="bannerIndex"
        />

        <div class="new-list" v-show="bannerIndex == 0">
          <div class="party-left">
            <div class="top-msg"> &nbsp;&nbsp;&nbsp;&nbsp; {{ partyNews.introduction }}</div>
            <div class="bottom-msg">
              <el-image
                class="bottom-img"
                lazy
                :src="baseURL + partyNews.cover"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
            </div>
          </div>
          <div class="party-right">
            <div class="timeline">
              <div
                class="entry"
                v-for="(item1, index1) in partyTimeList"
                :key="index1"
              >
                <div class="title">
                  <h3>{{ item1 }}</h3>
                </div>
                <div class="body">
                  <p v-for="(item2, index2) in partyList" :key="index2">
                    <span v-if="item1 == item2.title">
                      {{ item2.introduction }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="news2-wrap" v-show="bannerIndex == 1">
          <div
            style="cursor: pointer"
            v-for="(item, index) in newList"
            :key="index"
            class="news2-item"
          >
            <div>
              <el-image class="news2-img" lazy :src="baseURL + item.cover">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <p class="news2-item-title">{{ item.title }}</p>
            </div>
          </div>
        </div>

        <div class="news2-wrap" v-show="bannerIndex == 2">
          <div
            style="cursor: pointer"
            v-for="(item, index) in newList"
            :key="index"
            class="news2-item"
          >
            <div>
              <el-image class="news2-img" lazy :src="baseURL + item.cover">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
              </el-image>
              <p class="news2-item-title">{{ item.title }}</p>
            </div>
          </div>
        </div>

        <!-- <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            prev-text="上一页"
            next-text="下一页"
            :current-page.sync="page"
            :page-size="size"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </div>
      <div class="new-right"></div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { selectTNewsPage, getTNewsInfo } from "@/api/api.js";

export default {
  name: "news1",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: null,
      bannerIndex: 0,
      page: 1,
      size: 10,
      total: null,
      newList: [],
      newInfo: {},
      partyTimeList: [], //党建时间
      partyList: [], //党建时间线
      partyNews: [],
    };
  },
  created() {
    this.topIndex = this.$route.query.topIndex;
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));
    this.bannerIndex = Number(localStorage.getItem("lobannerIndex"));

    this.getData();
  },
  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "lobannerIndex") {
        // myKey是需要监听的键名
        that.lobannerIndex = e.newValue;
        that.bannerIndex = e.newValue;

        that.getData();
      }
    });
  },
  methods: {
    bannerIndexClick(index) {
      // this.bannerIndex = index
    },
    changeTips(index) {
      this.bannerIndex = index;
      this.getData();
    },
    async getData() {
      var params = {
        page: this.page,
        size: this.size,
        projectTypeParentId: this.bannerTipsList[this.bannerIndex]?.parentId,
        projectTypeSubId: this.bannerTipsList[this.bannerIndex]?.projectTypeId,
      };

      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
        this.newList = data.data.list;
        this.total = data.data.total;
      }

      //党建发展
      if (this.bannerIndex == 0) {
        this.partyList = this.newList.slice(1);
        this.partyNews = this.newList[0];
        this.partyList.forEach((item) => {
          item.title = Number(item.title); //转数字，方便排序
          this.partyTimeList.push(item.title);
        });
        this.partyTimeList.sort(function (a, b) {
          return b - a;
        });
        this.partyTimeList = [...new Set(this.partyTimeList)];
      }
    },

    //获取到文章详情
    async getNewInfo(newsId, projectTypeParentId) {
      const { data } = await getTNewsInfo({
        newsId: newsId,
        projectTypeParentId: projectTypeParentId,
      });
      this.newInfo = data.data;
    },
    jumpPage(item) {
      const routeUrl = this.$router.resolve({
        path: "/newDetails",
        query: {
          newsId: item.newsId,
          projectTypeParentId: item.projectTypeParentId,
          topIndex: this.topIndex,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;

  .new-center {
    background: #f4f4f4;

    .new-list {
      margin: 22px 0;
      background: #ffffff;
      width: 100%;
      box-sizing: border-box;
      padding: 20px;
      display: flex;
      justify-content: space-between;

      .party-left {
        width: 50%;

        .top-msg {
          font-size: 18px;
          padding: 20px;
          box-sizing: border-box;
          text-align: left;
          line-height: 30px;
          margin-bottom: 30px;
        }
        .bottom-msg {
          width: 100%;
          .bottom-img {
            width: 100%;
          }
        }
      }

      .party-right {
        width: 45%;
        height: 600px;
        overflow: auto;
        cursor: default;
      }

      // 滚动条样式
      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      ::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
      }
      ::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
    }

    .news2-wrap {
      margin-top: 22px;
      padding: 20px;
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .news2-item {
        width: 32%;
        height: 360px;
        background: #ffffff;
        text-align: left;
        cursor: pointer;
        margin-right: 2%;
        margin-bottom: 2%;
      }
      .news2-item:hover{
        transform: scale(1.1);
      }
      .news2-img {
        width: 100%;
        height: 300px;
      }

      .news2-item-title {
        width: 100%;
        font-size: 20px;
        line-height: 50px;
        text-align: center;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .news2-item:nth-child(3n) {
      margin-right: 0;
    }
    .news2-item:last-child {
      margin-right: auto;
    }

    .pagination {
      margin: 4% auto;
    }
  }
}

//时间轴

body {
  background: linear-gradient(55deg, #4e75b9 30%, #5cbf98 90%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 12vh 100px;
  font-family: "Source Sans Pro", arial, sans-serif;
  font-weight: 300;
  color: #333;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
}

.timeline {
  width: 100%;
  background: #fff;
  padding: 50px;
  position: relative;
}
.timeline::before {
  content: "";
  position: absolute;
  top: 0px;
  left: calc(33% + 15px);
  bottom: 0px;
  width: 4px;
  background: #ddd;
}
.timeline::after {
  content: "";
  display: table;
  clear: both;
}

.entry {
  clear: both;
  text-align: left;
  position: relative;
  .title {
    margin-bottom: 0.5em;
    float: left;
    width: 33%;
    padding-right: 30px;
    text-align: right;
    position: relative;

    h3 {
      margin: 0;
      font-size: 120%;
    }
    p {
      margin: 0;
      font-size: 100%;
    }
  }
  .body {
    margin: 0 0 3em;
    float: right;
    width: 66%;
    padding-left: 30px;
    p {
      line-height: 1.4em;

      span {
        font-size: 16px;
        line-height: 30px;
      }
    }
    p:first-child {
      margin-top: 0;
      font-weight: 400;
    }
  }
}

.title::before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border: 4px solid salmon;
  background-color: #fff;
  border-radius: 100%;
  top: 15%;
  right: -8px;
  z-index: 99;
}
//时间轴

@media only screen and (max-width: 1550px) {
  .new-left {
    flex: 1 !important;
  }

  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }

  .new-right {
    flex: 1 !important;
  }
}
</style>
